<template>
	<div class="">
		
		
		<div v-if="activeComponents.hotTrend" class="col-sm-12 col-md-6 col-lg-6 float-left">
			<component :is="components.hotTrend" zoom_start="0"></component>
		</div>
		<div v-if="activeComponents.hotDay" class="col-sm-12 col-md-6 col-lg-6 float-left">
			<component :is="components.hotDay" zoom_start="45"></component>
		</div>
		<div class="clearfix"></div>
		<div class="row mb-2">
			<div class="col-sm-3">
				<div class="d-flex align-items-center">
					<b-input-group size="sm" prepend="图高(px)" class="mr-2">
						<b-form-input type="number" v-model.number="chartHeightValue" min="300" max="1200" step="10"></b-form-input>
					</b-input-group>
					<b-button-group size="sm">
						<b-button variant="outline-secondary" @click="setHeight(350)">350</b-button>
						<b-button variant="outline-secondary" @click="setHeight(420)">420</b-button>
						<b-button variant="outline-secondary" @click="setHeight(550)">550</b-button>
						<b-button variant="outline-secondary" @click="setHeight(700)">700</b-button>
					</b-button-group>
				</div>
			</div>
		</div>
		<div v-if="activeComponents.upLimitSentiment" class="col-sm-12 col-md-12 col-lg-12 float-left">
			<component :is="components.upLimitSentiment" title="涨停情绪" subText="多日分时" modal="0" zoom_start="50" :chart_heigh="chartHeight"></component>
		</div>
		<div class="clearfix"></div>
		
		<div v-if="activeComponents.popularSentiment" class="col-sm-12 col-md-12 col-lg-12 float-left">
			<component :is="components.popularSentiment" title="人气情绪" subText="多日分时" modal="20" zoom_start="50" :chart_heigh="chartHeight"></component>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			components: {
				hotTrend: null,
				hotDay: null,
				upLimitSentiment: null,
				popularSentiment: null
			},
			activeComponents: {
				hotTrend: false,
				hotDay: false,
				upLimitSentiment: false,
				popularSentiment: false
			},
			chartHeightValue: 350,
			chartHeightKey: 'sentiment.chartHeight'
		}
	},
	computed:{
		chartHeight(){
			return `${this.chartHeightValue}px`
		}
	},
		methods: {
			loadComponent(componentName) {
				// 切换组件显示状态
				this.activeComponents[componentName] = !this.activeComponents[componentName];
				
				// 如果组件已加载，则不需要重新加载
				if (this.components[componentName]) return;
				
				// 根据组件名称动态加载对应组件
				switch(componentName) {
					case 'hotTrend':
						import('components/sentiment/SentimentMarketHotTrend.vue').then(module => {
							this.components.hotTrend = module.default;
						});
						break;
					case 'hotDay':
						import('components/sentiment/SentimentMarketHotDay.vue').then(module => {
							this.components.hotDay = module.default;
						});
						break;
					case 'upLimitSentiment':
						import('components/sentiment/SentimentTrend.vue').then(module => {
							this.components.upLimitSentiment = module.default;
						});
						break;
					case 'popularSentiment':
						import('components/sentiment/SentimentTrend.vue').then(module => {
						this.components.popularSentiment = module.default;
					});
					break;
			}
		}
		,setHeight(val){
			this.chartHeightValue = val
		}
	},
	watch:{
		chartHeightValue(val){
			try{ localStorage.setItem(this.chartHeightKey, String(val)); }catch(e){ this.chartHeightKey = this.chartHeightKey || '' }
		}
	},
		mounted() {
			// 默认加载热度趋势组件
			try{
				const v = localStorage.getItem(this.chartHeightKey);
				if(v){ const n = parseInt(v,10); if(!isNaN(n) && n>=300 && n<=1200){ this.chartHeightValue = n; } }
			}catch(e){ this.chartHeightKey = this.chartHeightKey || '' }
			this.loadComponent('hotTrend');
			this.loadComponent('hotDay');
			this.loadComponent('upLimitSentiment');
			this.loadComponent('popularSentiment');
			
		}
	}
</script>

<style scoped>
.mb-2 {
	margin-bottom: 1rem;
}
</style>
